"use client";

import { useMemo } from "react";
import { ManualLogSheet } from "@/app/_components/companion/ManualLogSheet";
import { conditionManualLogSheetView } from "./condition-manual-log";

type ConditionManualLogProps = {
  placeSlug: string;
  placeLabel: string;
  sport: string;
};

export function ConditionManualLog({
  placeSlug,
  placeLabel,
  sport,
}: ConditionManualLogProps) {
  const sheet = useMemo(
    () =>
      conditionManualLogSheetView({
        placeSlug,
        placeLabel,
        sport,
      }),
    [placeLabel, placeSlug, sport],
  );

  return (
    <ManualLogSheet
      view={sheet}
      title="Log a day"
      body={`Add ${placeLabel} to your private Companion record without GPS.`}
      triggerLabel="Log a day"
    />
  );
}
